/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { IcpDto } from '../models/icp-dto';

@Injectable({
  providedIn: 'root',
})
export class IdealCustomerProfileService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getIcp
   */
  static readonly GetIcpPath = '/user-profile/icp/{icpId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIcp()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIcp$Response(params: {
    icpId: string;
  }): Observable<StrictHttpResponse<IcpDto>> {

    const rb = new RequestBuilder(this.rootUrl, IdealCustomerProfileService.GetIcpPath, 'get');
    if (params) {
      rb.path('icpId', params.icpId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IcpDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getIcp$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIcp(params: {
    icpId: string;
  }): Observable<IcpDto> {

    return this.getIcp$Response(params).pipe(
      map((r: StrictHttpResponse<IcpDto>) => r.body as IcpDto)
    );
  }

  /**
   * Path part for operation getUserIcPs
   */
  static readonly GetUserIcPsPath = '/user-profile/icp';

  /**
   * Use the method for 'Do you have a list of your ideal customers?' == 'no'
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserIcPs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserIcPs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<IcpDto>>> {

    const rb = new RequestBuilder(this.rootUrl, IdealCustomerProfileService.GetUserIcPsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<IcpDto>>;
      })
    );
  }

  /**
   * Use the method for 'Do you have a list of your ideal customers?' == 'no'
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserIcPs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserIcPs(params?: {
  }): Observable<Array<IcpDto>> {

    return this.getUserIcPs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<IcpDto>>) => r.body as Array<IcpDto>)
    );
  }

  /**
   * Path part for operation uploadIcp
   */
  static readonly UploadIcpPath = '/user-profile/icp';

  /**
   * Use the method for 'Do you have a list of your ideal customers?' == 'no'
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadIcp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadIcp$Response(params?: {
    body?: IcpDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, IdealCustomerProfileService.UploadIcpPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Use the method for 'Do you have a list of your ideal customers?' == 'no'
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadIcp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  uploadIcp(params?: {
    body?: IcpDto
  }): Observable<void> {

    return this.uploadIcp$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation uploadIcpList
   */
  static readonly UploadIcpListPath = '/user-profile/icp/customerlist';

  /**
   * Use the method for 'Do you have a list of your ideal customers?' == 'yes'
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadIcpList()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadIcpList$Response(params?: {
    body?: {
'listFile'?: Blob;
'productCategories'?: Array<string>;
}
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, IdealCustomerProfileService.UploadIcpListPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Use the method for 'Do you have a list of your ideal customers?' == 'yes'
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadIcpList$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadIcpList(params?: {
    body?: {
'listFile'?: Blob;
'productCategories'?: Array<string>;
}
  }): Observable<void> {

    return this.uploadIcpList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
